import { isDefined } from '@sgme/fp';
import { LightAlert } from 'components/shared/LightAlert';
import type { IntlKey } from 'locales';
import { FormattedMessage } from 'react-intl';

interface MessageProps {
  labelId: IntlKey;
  message: string | undefined;
  isHidden: boolean;
  hide(): void;
}

function Message({ labelId, message, isHidden, hide }: MessageProps) {
  if (!isDefined(message) || isHidden) {
    return null;
  }
  return (
    <LightAlert severity="info" customIcon="chat_bubble_outline" className="mb-2">
      <div className="d-flex flex-column w-100">
        <div className="d-flex w-100 align-items-center">
          <FormattedMessage id={labelId} tagName="div" />
          <button type="button" className="btn btn-sm btn-icon btn-flat-info ms-auto" onClick={hide}>
            <i className="icon icon-sm">clear</i>
          </button>
        </div>
        <div className="mt-3 fw-normal">{message}</div>
      </div>
    </LightAlert>
  );
}

interface MessagesProps {
  salesMessage: string | undefined;
  isSalesMessageHidden: boolean;
  hideSalesMessage(): void;
  traderMessage: string | undefined;
  isTraderMessageHidden: boolean;
  hideTraderMessage(): void;
}

export function Messages({
  salesMessage,
  traderMessage,
  isSalesMessageHidden,
  hideSalesMessage,
  isTraderMessageHidden,
  hideTraderMessage,
}: MessagesProps) {
  return (
    <div className="d-flex flex-column">
      <Message
        labelId="secondaryMarket.productSummary.label.tradingMessage"
        message={traderMessage}
        isHidden={isTraderMessageHidden}
        hide={hideTraderMessage}
      />
      <Message
        labelId="secondaryMarket.productSummary.label.saleMessage"
        message={salesMessage}
        isHidden={isSalesMessageHidden}
        hide={hideSalesMessage}
      />
    </div>
  );
}
